import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section
      id="hero"
      className="relative w-full overflow-hidden"
      style={{ height: '100vh', minHeight: '100vh' }}
    >
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/17b7b4fe0c11dd66d6ca2f4f9437a472/17f0181c5c666dd6f25cb0f987bfd62c.png"
          alt="K-Grill183 Production Facility"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/60"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full text-center px-4 md:px-8">
        <div className="max-w-4xl mx-auto w-full">
          <p
            className="text-teal-400 text-xs md:text-sm font-semibold tracking-widest uppercase mb-4 md:mb-6 opacity-90"
            style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.25em' }}
          >
            K-Grill183
          </p>
          <h1
            className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 md:mb-8 leading-tight whitespace-pre-line"
            style={{ fontFamily: 'Noto Sans KR, sans-serif', wordBreak: 'keep-all' }}
          >
            {t('hero_title')}
          </h1>
          <div className="w-12 md:w-16 h-1 bg-teal-400 mx-auto mb-6 md:mb-8"></div>
          <p
            className="text-sm md:text-xl lg:text-2xl text-white/80 leading-relaxed md:leading-loose whitespace-pre-line"
            style={{ fontFamily: 'Noto Sans KR, sans-serif', wordBreak: 'keep-all' }}
          >
            {t('hero_description')}
          </p>
        </div>
      </div>
    </section>
  );
}
